import React, { useState, useEffect } from 'react';
import { McModal } from '@maersk-global/mds-react-wrapper/components-core/mc-modal';
import { McButton } from '@maersk-global/mds-react-wrapper/components-core/mc-button';
import { McIcon } from '@maersk-global/mds-react-wrapper/components-core/mc-icon';
import { McNotification } from '@maersk-global/mds-react-wrapper/components-core/mc-notification';
import { COLORS, SPACING, BORDER_RADIUS } from '../constants/theme';

const DomainRedirect = () => {
  const [countdown, setCountdown] = useState(15);
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user is on the old domain
    const hostname = window.location.hostname;
    const isOldDomain = hostname === 'lab-opticus.maersk.io' || hostname === 'lab-opticus-dev.maersk.io';
    
    if (isOldDomain) {
      setShow(true);
      
      // Start countdown
      const countdownInterval = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownInterval);
            // Always redirect to production domain
            window.location.href = `https://lab-neurix.maersk.io${window.location.pathname}${window.location.search}${window.location.hash}`;
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(countdownInterval);
    }
  }, []);

  if (!show) return null;

  const hostname = window.location.hostname;
  const isDevDomain = hostname === 'lab-opticus-dev.maersk.io';

  const goNow = () => {
    window.location.href = `https://lab-neurix.maersk.io${window.location.pathname}${window.location.search}${window.location.hash}`;
  };

  return (
    <McModal
      open
      dimension="small"
      heading="Opticus Lab is now Neurix Lab"
      hiddenclose
      backdropcloseactiondisabled
      escapecloseactiondisabled
      entercloseactiondisabled
    >
      <div style={{ textAlign: 'center' }}>
        {/* Icon */}
        <div style={{ marginBottom: SPACING.lg, display: 'flex', justifyContent: 'center' }}>
          <McIcon icon="arrow-right" size="24" color={COLORS.text} />
        </div>

        {/* Message */}
        <p className="mds-text--medium-normal" style={{
          margin: `0 0 ${isDevDomain ? SPACING.lg : SPACING.xl}px 0`,
          color: COLORS.textSecondary,
        }}>
          We've rebranded! You're being redirected to our new domain at <strong style={{ color: COLORS.text }}>lab-neurix.maersk.io</strong>
        </p>

        {/* Decommission Notice - Only show for dev domain */}
        {isDevDomain && (
          <div style={{ marginBottom: SPACING.xl, textAlign: 'left' }}>
            <McNotification appearance="warning" icon="exclamation-triangle" fit="small">
              <strong>Notice:</strong> {hostname} domain will be decommissioned on <strong>1 March 2026</strong>
            </McNotification>
          </div>
        )}

        {/* Countdown */}
        <div className="mds-headline--large" style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 80,
          height: 80,
          borderRadius: BORDER_RADIUS.full,
          backgroundColor: COLORS.primaryWeak,
          color: COLORS.text,
          marginBottom: SPACING.lg,
        }}>
          {countdown}
        </div>
      </div>

      {/* Redirect Button */}
      <McButton
        slot="primaryAction"
        appearance="primary"
        variant="filled"
        trailingicon="arrow-right"
        click={goNow}
      >
        Go Now
      </McButton>
    </McModal>
  );
};

export default DomainRedirect;
